interface ExepnseCounterProps {
  expenseCount: number | undefined;
}


export const ExepnseCounter = ({ expenseCount }: ExepnseCounterProps) => {
  return (
    <div className="flex flex-col items-center justify-center bg-primary/10 rounded-lg px-4 md:px-6 py-3 md:py-4 w-full sm:w-auto sm:min-w-[100px]">
      <div className="text-3xl md:text-4xl font-bold text-primary">{expenseCount}</div>
      <div className="text-xs md:text-sm text-muted-foreground mt-1">Expense{expenseCount !== 1 ? 's' : ''}</div>
    </div>
  )
}

